var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{ show : _vm.modalOpen },attrs:{"id":"modal"}},[_c('button',{staticClass:"modal-close",on:{"click":function($event){_vm.modalOpen = false}}},[_vm._v("×")]),_c('div',{staticClass:"modal-content"},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }